// extracted by mini-css-extract-plugin
export default {"tablehead":"TableCategory_tablehead__ZB2Um","custom-striped-table":"TableCategory_custom-striped-table__Zt6BC","icon":"TableCategory_icon__hTgx9"};